/**
 * The default timezone to use for dates where we're not sure what timezone to use.
 */
export const TIME_ZONE = 'Europe/London';
